import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { RootState } from '@/redux/store'

export interface ReferralCaseState {
  hasUserUpdatedStatus: boolean
  hasUserAddedNote: boolean
  isReferralStatusDropdownOpen: boolean
  isResendClientConsentProcessing: boolean
  resendClientConsentBeenShowIn: number
}

const INITIAL_STATE: ReferralCaseState = {
  hasUserUpdatedStatus: false,
  hasUserAddedNote: false,
  isReferralStatusDropdownOpen: false,
  isResendClientConsentProcessing: false,
  resendClientConsentBeenShowIn: 0,
}

const referralCase = createSlice({
  name: 'referralCase',
  initialState: INITIAL_STATE,
  reducers: {
    resetReferralCase() {
      return {
        ...INITIAL_STATE,
      }
    },

    setHasUserUpdatedStatus(state, action: PayloadAction<boolean>) {
      state.hasUserUpdatedStatus = action.payload
    },

    setHasUserAddedNote(state, action: PayloadAction<boolean>) {
      state.hasUserAddedNote = action.payload
    },

    setIsReferralStatusDropdownOpen(state, action: PayloadAction<boolean>) {
      state.isReferralStatusDropdownOpen = action.payload
    },

    setIsResendClientConsentProcessing(state, action: PayloadAction<boolean>) {
      state.isResendClientConsentProcessing = action.payload
    },

    setResendClientConsentBeenShowIn(state, action: PayloadAction<number>) {
      state.resendClientConsentBeenShowIn = action.payload
    },
  },
})

export const referralCaseReducer = referralCase.reducer

export const selectReferralCase = (state: RootState) => state.referralCase

export const {
  resetReferralCase,
  setHasUserUpdatedStatus,
  setHasUserAddedNote,
  setIsReferralStatusDropdownOpen,
  setIsResendClientConsentProcessing,
  setResendClientConsentBeenShowIn,
} = referralCase.actions
